import React from "react";

interface Rectangle2CutCornersProps {
  a?: string | number;
  b?: string | number;
  c?: string | number;
  d?: string | number;
  e?: string | number;
  f?: string | number;
  foldType?: string;
  foldDirection?: number;
  arrowColor?: string;
  textColor?: string;
}

const Rectangle2CutCorners: React.FC<Rectangle2CutCornersProps> = ({
  a = "",
  b = "",
  c = "",
  d = "",
  e = "",
  f = "",
  foldType = "",
  foldDirection = 1,
  arrowColor = "#1E8F31",
  textColor = "#000"
}) => {
  return (
    <svg
      width="263"
      height="235"
      viewBox="0 0 293 235"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Rectangle with 2 Cut Corners */}
      <path
        d="M174.783 39.6857L173.609 38.5H171.941H81C70.5066 38.5 62 47.0066 62 57.5V177.5C62 187.993 70.5066 196.5 81 196.5H170.95H172.619L173.793 195.314L218.842 149.814L220 148.645V147V87V85.3548L218.842 84.1857L174.783 39.6857Z"
        stroke="#1E8F31"
        strokeWidth="3"
      />

      {/* Arrows */}
      <path
        d="M58 17L64 20.4641V13.5359L58 17ZM175 17L169 13.5359V20.4641L175 17ZM63.4 17.6H169.6V16.4H63.4V17.6Z"
        fill={arrowColor}
      />
      <path
        d="M58 218L64 221.464V214.536L58 218ZM175 218L169 214.536V221.464L175 218ZM63.4 218.6H169.6V217.4H63.4V218.6Z"
        fill={arrowColor}
      />
      <path
        d="M49 176L45.5359 182H52.4641L49 176ZM49 200L52.4641 194H45.5359L49 200ZM48.4 181.4V194.6H49.6V181.4H48.4Z"
        fill={arrowColor}
      />
      <path
        d="M4 34L0.535898 40H7.4641L4 34ZM4 200L7.4641 194H0.535898L4 200ZM3.4 39.4L3.4 194.6H4.6L4.6 39.4H3.4Z"
        fill={arrowColor}
      />
      <path
        d="M188 17L189.793 23.6921L194.692 18.7932L188 17ZM244.5 73.5L242.707 66.8079L237.808 71.7068L244.5 73.5ZM191.394 21.2426L240.257 70.1059L241.106 69.2574L192.243 20.3941L191.394 21.2426Z"
        fill={arrowColor}
      />
      <path
        d="M244 84L240.536 90H247.464L244 84ZM244 150L247.464 144H240.536L244 150ZM243.4 89.4V144.6H244.6V89.4H243.4Z"
        fill={arrowColor}
      />

      {/* Letters */}
      <text fontFamily="Roboto" fontSize="12" y="114.99907" x="9.41714" fill={textColor}>
        A: {a}
      </text>
      <text textAnchor="middle" fontFamily="Roboto" fontSize="12" y="12.08282" x="121.91673" fill={textColor}>
        B: {b}
      </text>
      <text fontFamily="Roboto" fontSize="12" y="39.16604" x="220.6663" fill={textColor}>
        C: {c}
      </text>
      <text fontFamily="Roboto" fontSize="12" y="118.74906" x="249.83285" fill={textColor}>
        D: {d}
      </text>
      <text fontFamily="Roboto" fontSize="12" y="229.58194" x="100.83338" fill={textColor}>
        E: {e}
      </text>
      <text textAnchor="end" fontFamily="Roboto" fontSize="12" y="192.49876" x="42.66709" fill={textColor}>
        F: {f}
      </text>

      {/* Bi Fold V */}
      {foldType === "Bi-Fold" && foldDirection === 2 && (
        <line x1="141.6" y1="42" x2="141.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
      )}

      {/* Tri Fold V */}
      {foldType === "Tri-Fold" && foldDirection === 2 && (
        <>
          <line x1="112.6" y1="42" x2="112.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="169.5" y1="42" x2="169.5" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Quad Fold V */}
      {foldType === "Quad-Fold" && foldDirection === 2 && (
        <>
          <line x1="100.6" y1="42" x2="100.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="141.6" y1="42" x2="141.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="181.6" y1="45" x2="181.6" y2="188" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Five Fold V */}
      {foldType === "Five-Fold" && foldDirection === 2 && (
        <>
          <line x1="156.6" y1="42" x2="156.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="126.6" y1="42" x2="126.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="96.6" y1="42" x2="96.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="186.6" y1="52" x2="186.6" y2="182" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Six Fold V */}
      {foldType === "Six-Fold" && foldDirection === 2 && (
        <>
          <line x1="141.6" y1="42" x2="141.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="116.6" y1="42" x2="116.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="91.6" y1="42" x2="91.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="166.6" y1="42" x2="166.6" y2="192" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="191.6" y1="56" x2="191.6" y2="176" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Bi Fold H */}
      {foldType === "Bi-Fold" && foldDirection === 1 && (
        <line x1="66" y1="116.4" x2="216" y2="116.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
      )}

      {/* Tri Fold H */}
      {foldType === "Tri-Fold" && foldDirection === 1 && (
        <>
          <line x1="66" y1="88.4" x2="216" y2="88.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="145.4" x2="216" y2="145.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Quad Fold H */}
      {foldType === "Quad-Fold" && foldDirection === 1 && (
        <>
          <line x1="66" y1="76.4" x2="213" y2="76.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="116.4" x2="216" y2="116.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="157.4" x2="213" y2="157.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Five Fold H */}
      {foldType === "Five-Fold" && foldDirection === 1 && (
        <>
          <line x1="66" y1="102" x2="216" y2="102" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="131.4" x2="216" y2="131.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="71.4" x2="206" y2="71.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="161.4" x2="206" y2="161.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}

      {/* Six Fold H */}
      {foldType === "Six-Fold" && foldDirection === 1 && (
        <>
          <line x1="66" y1="92" x2="216" y2="92" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="116.4" x2="216" y2="116.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="66.4" x2="201" y2="66.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="166.4" x2="201" y2="166.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
          <line x1="66" y1="141.4" x2="216" y2="141.4" stroke="#1E8F31" strokeWidth="1.2" strokeDasharray="6 6" />
        </>
      )}
    </svg>
  );
};

export default Rectangle2CutCorners;

